import { IconLink } from "./IconLink";

export { IconLink };
